module.exports = __webpack_public_path__ + "Roboto-Regular.766c8926f6d9061fef24.svg";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Regular.svg
// module id = 85
// module chunks = 17